/**
 * DocumentVisibilityModal — Iter63b-bis-fix Feature B
 *
 * Modale d'édition de la visibilité d'un doc EXISTANT.
 * Réutilise DocumentVisibilityForm. Save via PUT /api/documents/{did}/visibility.
 */
import { useEffect, useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { toast } from "sonner";
import DocumentVisibilityForm, { DEFAULT_INTERNAL_VISIBILITY } from "./DocumentVisibilityForm";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function DocumentVisibilityModal({ doc, chantierId, open, onClose, onUpdated }) {
  const [visibleTo, setVisibleTo] = useState([]);
  const [visibleToSpecificUsers, setVisibleToSpecificUsers] = useState([]);
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (doc && open) {
      setVisibleTo(doc.visible_to && doc.visible_to.length ? doc.visible_to : [...DEFAULT_INTERNAL_VISIBILITY]);
      setVisibleToSpecificUsers(doc.visible_to_specific_users || []);
      setNote(doc.moderation_note || "");
    }
  }, [doc, open]);

  const handleSave = async () => {
    if (!doc) return;
    setSaving(true);
    try {
      await axios.put(
        `${API_URL}/api/documents/${doc.id || doc._id}/visibility`,
        {
          visible_to: visibleTo,
          visible_to_specific_users: visibleToSpecificUsers,
          moderation_note: note || null,
        },
        { withCredentials: true }
      );
      toast.success("Visibilité mise à jour");
      if (typeof onUpdated === "function") onUpdated();
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur");
    } finally {
      setSaving(false);
    }
  };

  if (!doc) return null;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md max-h-[85vh] overflow-y-auto" data-testid="visibility-modal">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'DM Serif Display, serif' }}>
            Visibilité du document
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="text-sm text-[#2C2C2C] font-medium truncate">{doc.name}</div>
          <DocumentVisibilityForm
            visibleTo={visibleTo}
            setVisibleTo={setVisibleTo}
            visibleToSpecificUsers={visibleToSpecificUsers}
            setVisibleToSpecificUsers={setVisibleToSpecificUsers}
            note={note}
            setNote={setNote}
            chantierId={chantierId}
            testIdPrefix="edit-visibility"
          />
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={onClose} disabled={saving} className="rounded-none" data-testid="visibility-cancel">
              Annuler
            </Button>
            <Button onClick={handleSave} disabled={saving} className="bg-[#2C2C2C] hover:bg-[#4A4A4A] rounded-none" data-testid="visibility-save">
              {saving ? "Enregistrement…" : "Enregistrer"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
